var map = {
	"./logo-chat-sm.svg": 15302,
	"./promo.svg": 5664,
	"./site-logo-desktop-footer.svg": 31643,
	"./site-logo-desktop.svg": 26029,
	"./site-logo-drawer-mobile.svg": 63551,
	"./site-logo-drawer.svg": 20748,
	"./site-logo-mobile-drawer.svg": 33497,
	"./site-logo-mobile.svg": 82105,
	"./site-logo-sm.svg": 39123,
	"./site-logo-tv.svg": 12897,
	"./site-logo-wrapper-mobile-scrolled.svg": 55036,
	"./site-logo-wrapper-mobile.svg": 77523,
	"./site-logo-wrapper-scrolled.svg": 96613,
	"./site-logo-wrapper.svg": 12720
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36301;